import React, { Fragment, useEffect, useState } from 'react';
import { setPayment } from "../../../main/slices/transactionSlice";
import { validateInvoice } from "../../../main/slices/storeSlice";
import { jump } from "../../../main/slices/routerSlice";
import { updateInvoice } from "../../../main/slices/storeSlice";
import { useDispatch, useSelector } from 'react-redux';

const Line = ({ style = {}, classes = [], children, qr}) => {
  let totalTime = 900;
  let setColor= "#99b83c";
  const dispatch = useDispatch();
  const [remaining, setRemaining] = useState(totalTime);
  const stateTrx = useSelector(({ transaction }) => transaction);
  const store = useSelector(({ store }) => store);

  //IF TRANSACTIONS ERROR
  const updTrx = async (trxStatus) => {
    return await dispatch(updateInvoice({
      "status": `${trxStatus}`,
      "trxId": `${stateTrx.idTransaction.value}`,
      "store": `${store.idStore.value}`
    })).unwrap()
      .then(({ response }) => {
        return true;
      })
      .catch(e => {
        return false
      });
  };

  const validateInfoTransaction = async () => {
    return await dispatch(validateInvoice({
      "amountWLD": stateTrx.total.value, 
      "amountLocal": stateTrx.amount.value,
      "store": `${store.idStore.value}`,
      "id": `${stateTrx.idTransaction.value}`
    })).unwrap()
        .then(({ response }) => {
          if (response.code==200) {
            dispatch(setPayment({value: false, error: false}));
            dispatch(jump({ current: 12, direction: "forward" }));
            return true;
          }else if(response.code!=200 && response.code!=201){
            updTrx("rejected");
            dispatch(setPayment({value: true, error: true}));
            dispatch(jump({ current: 12, direction: "forward" }));
            return true;
          }
        })
        .catch(e => {
          dispatch(setPayment({value: true, error: true}));
          dispatch(jump({ current: 12, direction: "forward" }));
          return true
        });
  };
  
  // ---- RESET CONTADOR ----
  useEffect(() => {
    setRemaining(totalTime); // reinicio al montar
  }, [totalTime]);

  // ---- CONTADOR ----
  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // ---- MITAD DEL TIEMPO TOTAL ----
  const halfTime = totalTime / 2; // 450s
  
  // ---- PORCENTAJE ----
  let percentage = ((totalTime - remaining) / totalTime) * 100;

  // ---- CAMBIO DE COLORES ----
  if (remaining > halfTime) {
    setColor = "#99b83c"; // VERDE
  }else if(remaining <= halfTime && remaining > 10){//Cambia color a naranja
    setColor= "#f5a200";
  }else if(remaining <= 10){//rojo para los ultimos 10 segundos
    setColor= "#e20f0fff";
  }

  //MUESTRO PANTALLA DE TIME-OUT
  if (remaining === 0) {
    dispatch(jump({ current: 13, direction: "forward" }));
  }

  if(remaining !== 0 && remaining % 10 === 0){
    validateInfoTransaction();
  }

  // Cálculo del tiempo restante (mm:ss)
  const minutes = String(Math.floor(remaining / 60)).padStart(2, "0");
  const seconds = String(remaining % 60).padStart(2, "0");


  return (
    <div style={{ textAlign: "center", fontFamily: "sans-serif" }}>
      <h2 style={{ color: `${setColor}`, marginBottom: "10px" }}>
        EXPIRA EN: {minutes}:{seconds}
      </h2>
      <div
        style={{
          background: "#e6e6e6",
          borderRadius: "20px",
          overflow: "hidden",
          height: "20px",
          width: "300px",
          margin: "0 auto",
          border: "1px solid #ccc",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${percentage}%`,
            background: `${setColor}`,
            transition: "width 0.5s linear",
          }}
        />
      </div>
    </div>
  );
};

export const TimerLine = ({ style = {}, classes = [], children, qr }) => (
    <Fragment>
        <Line {...{ style, classes: [...classes, 'stack'], children, qr }}/>
    </Fragment>
);
